<template>
  <div>
    <rabbey-table-3
      show-summary
      sum-text="Total por Mes"
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
    />
  </div>
</template>

<script>
import { columns } from "@/columns/RequestReportByModuleByMonth/RequestReportByModuleByMonthColumns";

const actualYear = new Date().getFullYear();

export default {
  name: "ReportByModuleByMonthTable",
  props: {
    yearSelected: {
      type: Number,
      default: actualYear
    },
    thecnicianSelected: {
      type: Number,
      default: 0
    },
    customerServiceCode: {
      type: Number,
      default: 0
    },
    requestTypeSelected: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: [],
      reportDataLoading: false,
      months: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      }
    };
  },

  mounted() {
    this.GetReportData();
  },

  methods: {
    async GetReportData() {
      this.reportDataLoading = true;
      await this.$http
        .get("api/serviceRequests/Get_External_Request_Report_By_Modules", {
          params: {
            year: this.yearSelected,
            responsibleId: this.thecnicianSelected,
            requestType: this.requestTypeSelected,
            customerServiceCode: this.customerServiceCode,
            companyCode: this.currentCompany
          }
        })
        .then((response) => {
          this.reportData = response.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    },
    OpenDialodDetailList(column, row) {
      this.$emit(
        "OpeningDetailDialosg",
        true,
        this.months[column.property],
        row.ModuleIdVF,
        row.ModuleDescription
      );
    }
  },
  watch: {
    async yearSelected() {
      await this.GetReportData();
    },
    async thecnicianSelected() {
      await this.GetReportData();
    },
    async requestTypeSelected() {
      await this.GetReportData();
    },
    async customerServiceCode() {
      await this.GetReportData();
    }
  }
};
</script>

<style scoped></style>
